import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PageSkeleton } from '@euroasiann/shared/ui';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, loading, user, connectionError } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen p-8">
        <PageSkeleton variant="cards" />
      </div>
    );
  }

  // Only redirect if we've finished loading and user is not authenticated
  // Check both isAuthenticated and user to be sure
  if (!loading && !isAuthenticated && !user) {
    if (connectionError && localStorage.getItem('accessToken')) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[#f4f6f8] app-scaling">
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-[#0088cc]/15 flex flex-col items-center gap-4 max-w-sm text-center">
            <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center text-red-500 mb-2">
              <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[hsl(var(--foreground))]">Connection Failed</h3>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mb-2">Unable to connect to the server. The connection might have timed out or the server is temporarily unavailable.</p>
            <button
              onClick={() => window.location.reload()}
              className="w-full py-2.5 bg-[#0088cc] text-white rounded-xl font-semibold shadow hover:bg-[#0077b3] transition-colors"
            >
              Retry Connection
            </button>
          </div>
        </div>
      );
    }
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}







